import ReactDOM from "react-dom/client";
import App from "./components/app/app";
import "./index.scss";
import { GoogleOAuthProvider } from "@react-oauth/google";
import React from "react";
import "bootstrap/dist/css/bootstrap.css";
import { Provider } from "react-redux";
import { store } from "./redux/store/store";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const rootElement = document.querySelector("#root");
const root = ReactDOM.createRoot(rootElement! as HTMLElement);

root.render(
  <GoogleOAuthProvider clientId="15070580935-l6io8l2pgncesvr3dbkrcgs3drmr4ov9.apps.googleusercontent.com">
    <React.StrictMode>
      <Provider store={store}>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="dark"
        />
        <App />
      </Provider>
    </React.StrictMode>
  </GoogleOAuthProvider>
);
